import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';

export default function NavMenu() {
  const {
    whiteLabelSettings: { overviewLogoLarge = false },
  } = useWhiteLabelSettings();
  const { componentConfig, latestBookings, latestQuotes } = useSelector(
    (state) => state.ui,
  );

  return (
    <nav className={`z-[3] hidden lg:block ${overviewLogoLarge ? 'min-h-[6.5rem]' : 'min-h-[70px]'}`}>
      <ul className={`${overviewLogoLarge ? 'm-8' : 'm-4'} flex gap-[40px] pl-5 text-white`}>
        {latestBookings?.length > 0 && componentConfig.bookingsEnabled && (
          <li className="font-bold pt-3">
            <Link to={ROUTES_SELF_SERVICE.BOOKINGS}>Bookings</Link>
          </li>
        )}
        {latestQuotes?.length > 0 && componentConfig.quotesEnabled && (
          <li className="font-bold pt-3">
            <Link to={ROUTES_SELF_SERVICE.QUOTES}>Quotes</Link>
          </li>
        )}
        {componentConfig.documentsEnabled && (
          <li className="font-bold pt-3">
            <Link to={ROUTES_SELF_SERVICE.DOCUMENTS}>My Travel Documents</Link>
          </li>
        )}
        {componentConfig.profileEnabled && (
          <li className="font-bold pt-3">
            <Link to={ROUTES_SELF_SERVICE.PROFILE}>Personal Details</Link>
          </li>
        )}
      </ul>
    </nav>
  );
}
